import { render, staticRenderFns } from "./FormMetaDashboard.vue?vue&type=template&id=2014c85e&lang=pug"
import script from "./FormMetaDashboard.vue?vue&type=script&lang=js"
export * from "./FormMetaDashboard.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/jquispe/itcm-inca-platform-app/frontend/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('2014c85e')) {
      api.createRecord('2014c85e', component.options)
    } else {
      api.reload('2014c85e', component.options)
    }
    module.hot.accept("./FormMetaDashboard.vue?vue&type=template&id=2014c85e&lang=pug", function () {
      api.rerender('2014c85e', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/tableau/FormMetaDashboard.vue"
export default component.exports